import PlayerDetailedStatsFilters from "./PlayerDetailedStatsFilters";

export default class FantasyPlayerDetailedStatsMetaModel {
  public filters: PlayerDetailedStatsFilters = new PlayerDetailedStatsFilters();
}
